export abstract class UnicodeChars {
  static readonly LINE_FEED = '\u000A'; // Saut de ligne \n &NewLine;
  static readonly NARROW_NO_BREAK_SPACE = '\u202F'; // Espace FIN insécable &#x202F;
  static readonly NO_BREAK_SPACE = '\u00A0'; // Espace insécable &nbsp;
  static readonly SPACE = '\u0020';
}
